export default __webpack_public_path__ + "static/media/73_mobile.1144dde3.jpg";